import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ordinal',
    standalone: false,
})
export class OrdinalPipe implements PipeTransform {
    private readonly pr = new Intl.PluralRules('en', {
        type: 'ordinal',
    });

    private readonly suffixes: Record<string, string> = {
        one: 'st',
        two: 'nd',
        few: 'rd',
        other: 'th',
    };

    transform(value: number): string {
        return `${value}${this.suffixes[this.pr.select(value)]}`;
    }
}
